import React from 'react';
import { motion } from 'framer-motion';
const points = [{
  id: 1,
  title: 'Precisión Láser',
  desc: 'Intervenciones mínimamente invasivas. Olvídate del torno tradicional y el dolor asociado.',
  img: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=800&q=80'
}, {
  id: 2,
  title: 'Escaneo Digital 3D',
  desc: 'Impresiones digitales exactas en segundos. Sin pastas incómodas ni esperas interminables.',
  img: 'https://cdn.magicpatterns.com/uploads/uVQgEP7taKvPWCTC39Eghx/Imagen_2.jpg'
}, {
  id: 3,
  title: 'Atmósfera Zen',
  desc: 'Un entorno diseñado para tu relajación total. La ansiedad dental es cosa del pasado.',
  img: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=800&q=80'
}];
export function PainPoints() {
  return <section className="py-24 bg-ivory relative z-20" data-id="element-78" data-mp="3idbcxn1v6bc6">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-79" data-mp="3ibs1qav2eqh9">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-16" data-id="element-80" data-mp="3nbd0ak6bowtg">
          <h2 className="font-serif text-3xl md:text-5xl text-ink mb-4" data-id="element-81" data-mp="23sga8cb9woua">
            Tu Transformación{' '}
            <span className="text-gold-deep italic" data-id="element-82" data-mp="1g2lyjy2ox6bm">Sin Dolor</span>
          </h2>
          <p className="font-sans text-ink-soft max-w-2xl mx-auto" data-id="element-83" data-mp="1b3hqxbvezgne">
            Hemos redefinido la experiencia odontológica integrando tecnología
            de vanguardia para garantizar tu máximo confort.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-84" data-mp="1k5ilg0z9jold">
          {points.map((point, index) => <motion.div key={point.id} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-surface rounded-lg overflow-hidden group border border-line flex flex-col shadow-[0_2px_12px_rgba(21,32,46,0.05)]" data-id="element-85" data-mp="30jh4r69z9u9d" data-mpi={index}>
              <div className="h-64 overflow-hidden relative" data-id="element-86" data-mp="1efzb4jm3d5o2">
                <img src={point.img} alt={point.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-87" data-mp="1ee66f9v1gvip" />
              </div>
              <div className="p-8 flex flex-col flex-1" data-id="element-88" data-mp="qrg4e8iox0y3">
                <h3 className="font-serif text-xl text-ink mb-3" data-id="element-89" data-mp="qoty0c7jcrhg">
                  {point.title}
                </h3>
                <p className="font-sans text-ink-soft text-sm leading-relaxed" data-id="element-90" data-mp="o601zajba0ad">
                  {point.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}